import { PageHead } from "@generalapplications/html-render/react";
import { ArticleContent } from "@/app/features/content/components/ArticleContent";
import { PageHero } from "@/app/common/components/composite/layout/PageHero";
import { privacyPage } from "@/content/privacy";
import { pageHead } from "@/app/common/functions/seo/pageHead";
import { routes } from "@/app/common/functions/routes/routes";
import { PageArticle } from "@generalapplications/ui";

export function PrivacyPage() {
  const head = pageHead({
    path: routes.privacy,
    title: privacyPage.seoTitle,
    description: privacyPage.seoDescription,
  });

  return (
    <PageArticle rhythm="xl">
      <PageHead head={head} />
      <PageHero
        eyebrow={privacyPage.eyebrow}
        headline={privacyPage.headline}
        copy={privacyPage.heroCopy}
        size="document"
      />
      <ArticleContent blocks={privacyPage.content} figureComponents={{}} />
    </PageArticle>
  );
}
